export default "__VITE_ASSET__08631617__"